module.exports = ".limit-warning-container {\n  background: var(--color-s1-6);\n  height: 40px; }\n\n.limit-warning-text {\n  color: var(--color-p1-2);\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  padding-top: 10px;\n  font-weight: 700; }\n\n.support-email-link {\n  color: var(--color-p1-2);\n  text-decoration: underline; }\n\n.support-email-link:hover {\n  color: var(--color-p1-2); }\n\n.warning-icon {\n  padding: 0 4px 4px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/limit-warning/limit-warning.component.scss
// module id = ./client/app/limit-warning/limit-warning.component.scss
// module chunks = main